import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Vat, CreateVatDto, UpdateVatDto } from '../interfaces/vat.interface';
import { ApiResponse } from '../interfaces/api.interface';

@Injectable({
  providedIn: 'root'
})
export class VatsService {
  private readonly apiUrl = '/api/company/vats';

  constructor(private http: HttpClient) {}

  /**
   * Get all VAT zones for current company
   */
  getAll(): Observable<ApiResponse<Vat[]>> {
    return this.http.get<ApiResponse<Vat[]>>(this.apiUrl);
  }

  /**
   * Get VAT zone by ID
   */
  getById(id: number): Observable<ApiResponse<Vat>> {
    return this.http.get<ApiResponse<Vat>>(`${this.apiUrl}/${id}`);
  }

  /**
   * Create new VAT zone
   */
  create(dto: CreateVatDto): Observable<ApiResponse<Vat>> {
    return this.http.post<ApiResponse<Vat>>(this.apiUrl, dto);
  }

  /**
   * Update VAT zone
   */
  update(id: number, dto: UpdateVatDto): Observable<ApiResponse<Vat>> {
    return this.http.put<ApiResponse<Vat>>(`${this.apiUrl}/${id}`, dto);
  }

  /**
   * Delete VAT zone
   */
  delete(id: number): Observable<ApiResponse<void>> {
    return this.http.delete<ApiResponse<void>>(`${this.apiUrl}/${id}`);
  }

  /**
   * Toggle VAT zone active status
   */
  toggleActive(id: number): Observable<ApiResponse<Vat>> {
    return this.http.put<ApiResponse<Vat>>(`${this.apiUrl}/${id}/toggle-active`, {});
  }
}
